import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EventService, JobsService } from '../../../services';
import { IInteractionJobRef } from '../../../interfaces/interactions/interaction-job-ref';
import { Subscription } from 'rxjs';
import { InteractionEventTypeEnum } from '../../../interfaces/interactions/interaction-event';

@Component({
  selector: 'interaction-job-selector',
  styleUrls: ['./interaction-job-selector.component.scss'],
  templateUrl: './interaction-job-selector.component.html',
})
export class InteractionsJobSelectorComponent implements OnInit, OnDestroy {
  constructor(private jobService: JobsService, private eventService: EventService) {}

  public jobs: IInteractionJobRef[];
  public jobInfos: IInteractionJobRef[];
  public suggestedJobInfos: IInteractionJobRef[];

  _jobRefId: number;
  @Input() get jobRefId(): number {
    return this._jobRefId;
  }
  set jobRefId(val: number) {
    if (this._jobRefId != val) {
      this._jobRefId = val;
      this.loadSelectedJob();
    }
  }

  _organisationId: number;
  @Input() get organisationId(): number {
    return this._organisationId;
  }

  set organisationId(val: number) {
    if (this._organisationId != val) {
      this._organisationId = val;
      this.loadSuggestedJobs();
    }
  }

  @Output() jobRefSelected: EventEmitter<number> = new EventEmitter<number>();

  public selectedJob: IInteractionJobRef[];
  public searchText: string;
  eventSub: Subscription;

  ngOnInit() {
    this.eventSub = this.eventService.InteractionEvent.subscribe((event) => {
      if (event.eventType === InteractionEventTypeEnum.ResetJobSearchText) {
        this.searchText = '';
      }
    });

    this.loadJobRefs();
  }

  ngOnDestroy() {
    if (this.eventSub) {
      this.eventSub.unsubscribe();
    }
  }

  async loadSelectedJob() {
    if (this.jobRefId) {
      // see if we have the job in our job refs list
      this.selectedJob = [];
      let job = this.jobs.find((x) => x.id == this.jobRefId);

      // if not we'll have to load it
      if (!job) {
        await this.jobService.getInteractionJobRef(this.jobRefId).then((res) => {
          job = res;
        });
      }

      if (job) {
        job.selected = true;
        this.selectedJob.push(job);
      }
    }
  }

  loadSuggestedJobs() {
    this.jobService.getInteractionSuggestedJobs(this.organisationId).then((res) => {
      this.suggestedJobInfos = res;
      this.jobInfos = this.suggestedJobInfos;

      console.log('Suggested jobs: ', this.suggestedJobInfos);
    });
  }

  loadJobRefs() {
    this.jobService.getInteractionJobRefs().then(async (res) => {
      this.jobs = res;
    });
  }

  searchTextChanged(text: any) {
    //console.log("SEARCH TEXT: ", text);

    // filter the current results by name when 3 chars or more
    if (text && text.length >= 3) {
      this.jobInfos = this.jobs.filter(
        (x) => x.jobNumber && x.jobNumber.toLowerCase().indexOf(text.toLowerCase()) >= 0,
      );
    } else {
      this.jobInfos = this.suggestedJobInfos;
    }
  }

  jobSelected(job: IInteractionJobRef) {
    this.jobRefId = job.id;
    this.jobRefSelected.emit(job.id);
  }

  removeJobRef() {
    this.jobRefId = null;
    this.jobRefSelected.emit(null);
  }
}
